// extracted by mini-css-extract-plugin
export var actionButton = "_ql-0";
export var actionMenuContainer = "_ql-i";
export var bubble = "_ql-2";
export var bubbleActionMenu = "_ql-j";
export var bubbleContext = "_ql-6";
export var bubbleItems = "_ql-7";
export var customer = "_ql-3";
export var divider = "_ql-8";
export var fileList = "_ql-9";
export var hiddenComment = "_ql-o";
export var infoAbove = "_ql-a";
export var internal = "_ql-4";
export var lightActionButton = "_ql-1";
export var link = "_ql-b";
export var merchant = "_ql-5";
export var message = "_ql-c";
export var profilePicture = "_ql-e";
export var quillToolbarContainer = "_ql-f";
export var senderDate = "_ql-g";
export var senderDateCustomer = "_ql-h";
export var senderName = "_ql-d";
export var time = "_ql-k";
export var uploadedImage = "_ql-l";
export var username = "_ql-m";
export var xsmall = "_ql-n";